import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

// Import translation files
import arCommon from './locales/ar/common.json';
import enCommon from './locales/en/common.json';
import itCommon from './locales/it/common.json';

import arHome from './locales/ar/home.json';
import enHome from './locales/en/home.json';
import itHome from './locales/it/home.json';

import arProducts from './locales/ar/products.json';
import enProducts from './locales/en/products.json';
import itProducts from './locales/it/products.json';

import arComponents from './locales/ar/components.json';
import enComponents from './locales/en/components.json';
import itComponents from './locales/it/components.json';

import arAbout from './locales/ar/about.json';
import enAbout from './locales/en/about.json';
import itAbout from './locales/it/about.json';

// ✅ Import contact translation files
import arContact from './locales/ar/contact.json';
import enContact from './locales/en/contact.json';
import itContact from './locales/it/contact.json';

// ✅ Import privacy_policy translation files
import arPrivacyPolicy from './locales/ar/privacy_policy.json';
import enPrivacyPolicy from './locales/en/privacy_policy.json';
import itPrivacyPolicy from './locales/it/privacy_policy.json';

// Initialize i18next
i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: 'ar',
        supportedLngs: ['en', 'ar', 'it'],
        resources: {
            ar: {
                common: arCommon,
                home: arHome,
                products: arProducts,
                components: arComponents,
                about: arAbout,
                contact: arContact, // ✅ added
                privacy_policy: arPrivacyPolicy, // ✅ added
            },
            en: {
                common: enCommon,
                home: enHome,
                products: enProducts,
                components: enComponents,
                about: enAbout,
                contact: enContact, // ✅ added
                privacy_policy: enPrivacyPolicy, // ✅ added
            },
            it: {
                common: itCommon,
                home: itHome,
                products: itProducts,
                components: itComponents,
                about: itAbout,
                contact: itContact, // ✅ added
                privacy_policy: itPrivacyPolicy, // ✅ added
            },
        },
        ns: ['common', 'home', 'products', 'components', 'about', 'contact', 'privacy_policy'], // ✅ added "contact" and "privacy_policy"
        defaultNS: 'common',
        interpolation: {
            escapeValue: false, // React already escapes values
        },
        detection: {
            order: ['localStorage', 'cookie', 'navigator', 'htmlTag', 'path', 'subdomain'],
            caches: ['localStorage', 'cookie'],
        },
        react: {
            useSuspense: false,
        },
        // debug: process.env.NODE_ENV === "development",
    });

export default i18n;
